


































import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ProfessionalLayout extends Vue {
  get title() {
    return this.$route.meta.title || "Bem Cuidar :: Profissional";
  }
}
